import { BaSeParagraph, BaSeTheme } from '@base/react';
import React from 'react';
import logo_unctad from '../../assets/logo-unctad.png';
import pessoas from '../../assets/pessoas.png';
import {
  Container,
  ContainerPeoples,
  ImageContainer,
  ImageContent,
  TextContent,
} from './style';
function Apresentation() {
  return (
    <Container id="1">
      <ImageContainer>
        <ImageContent>
          <ContainerPeoples>
            <img src={pessoas} alt="pessoas" />
          </ContainerPeoples>
          <TextContent>
            <BaSeParagraph color={BaSeTheme.colors.defaultColors.white}>
              O Empretec é o principal programa de formação de empreendedores do
              mundo, um seminário intensivo criado pela Organização das Nações
              Unidas (ONU), promovido em 40 países e exclusivo do Sebrae no
              Brasil.
            </BaSeParagraph>
            <img src={logo_unctad} alt="logo_unctad" width="70%" />
          </TextContent>
        </ImageContent>
      </ImageContainer>
    </Container>
  );
}

export default Apresentation;
